module.exports = __webpack_public_path__ + "assets/img/NPC013.07388a17.png";